<template>
  <div class="page-decorations" aria-hidden="true">
    <!-- Always-visible corner accents -->
    <div class="deco-corner deco-corner-tl"></div>
    <div class="deco-corner deco-corner-tr"></div>
    <div class="deco-corner deco-corner-bl"></div>
    <div class="deco-corner deco-corner-br"></div>

    <!-- Left side -->
    <div class="deco-side deco-side-left">
      <div class="deco-orb deco-orb-1"></div>
      <div class="deco-orb deco-orb-2"></div>
      <div class="deco-ring deco-ring-1"></div>
      <div class="deco-dots"></div>
      <svg class="deco-svg deco-svg-left" viewBox="0 0 120 400" fill="none">
        <path d="M60 0 Q120 100 60 200 Q0 300 60 400" stroke="url(#gradLeft)" stroke-width="2" opacity="0.55"/>
        <path d="M30 40 Q90 140 30 240 Q-30 340 30 440" stroke="url(#gradLeft)" stroke-width="1.5" opacity="0.35"/>
        <defs>
          <linearGradient id="gradLeft" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#3b82f6"/>
            <stop offset="100%" stop-color="#818cf8"/>
          </linearGradient>
        </defs>
      </svg>
      <div class="deco-float deco-float-1">✦</div>
      <div class="deco-float deco-float-2">○</div>
    </div>

    <!-- Right side -->
    <div class="deco-side deco-side-right">
      <div class="deco-orb deco-orb-3"></div>
      <div class="deco-orb deco-orb-4"></div>
      <div class="deco-ring deco-ring-2"></div>
      <div class="deco-dots deco-dots-right"></div>
      <svg class="deco-svg deco-svg-right" viewBox="0 0 120 400" fill="none">
        <path d="M60 0 Q0 100 60 200 Q120 300 60 400" stroke="url(#gradRight)" stroke-width="2" opacity="0.55"/>
        <path d="M90 60 Q30 160 90 260 Q150 360 90 460" stroke="url(#gradRight)" stroke-width="1.5" opacity="0.35"/>
        <defs>
          <linearGradient id="gradRight" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#6366f1"/>
            <stop offset="100%" stop-color="#38bdf8"/>
          </linearGradient>
        </defs>
      </svg>
      <div class="deco-float deco-float-3">◇</div>
      <div class="deco-float deco-float-4">✦</div>
    </div>

    <!-- Page-wide mesh + dot grid -->
    <div class="deco-mesh"></div>
    <div class="deco-grid"></div>
  </div>
</template>

<script>
export default { name: 'PageDecorations' }
</script>
